var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsDevGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-dev_guide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10908",
    "data-name": "Path 10908",
    d: "M7.836,18.646l.5.095v1.292l-.765-.214a7.942,7.942,0,0,0-4.829.128.645.645,0,0,1-.557-.109.628.628,0,0,1-.248-.5V9.111a.638.638,0,0,1,.47-.613,8.167,8.167,0,0,1,5.573.052l.349.16v1.426l-.945-.543a6.829,6.829,0,0,0-4.252-.05v9.072A8.7,8.7,0,0,1,7.836,18.646ZM15.323,8.5a8.17,8.17,0,0,0-5.575.052L9.4,8.721v1.426l.945-.554a6.829,6.829,0,0,1,4.252-.05v9.072a8.648,8.648,0,0,0-4.7.036s-.5.1-.5.1v1.292l.765-.223a7.944,7.944,0,0,1,4.83.128.645.645,0,0,0,.557-.109.628.628,0,0,0,.249-.5V9.111A.638.638,0,0,0,15.323,8.5Zm-8,2.717v1.243l.885-.27a3.4,3.4,0,0,1,.943-.04c.5.044.516.222.53.38a.739.739,0,0,1-.251.717l-.919.694-.015.012a.768.768,0,0,0-.287.6l.006,1.271H9.408V14.757l.749-.566.014-.011a1.932,1.932,0,0,0,.7-1.757,1.587,1.587,0,0,0-1.616-1.466,4.109,4.109,0,0,0-1.517.117Zm.812,6.5H9.476V16.367H8.132Z",
    transform: "translate(-0.865 -6.293)",
    fill: "#c6cacc"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDevGuide);
export default __webpack_public_path__ + "static/media/icons-dev-guide.7e070198.svg";
export { ForwardRef as ReactComponent };